export default __webpack_public_path__ + "static/team-natalia-54ab503909dd65999eae9136d60a7495.png";